import { render, staticRenderFns } from "./EventBriefing.vue?vue&type=template&id=0adb041d&scoped=true&"
import script from "./EventBriefing.vue?vue&type=script&lang=ts&"
export * from "./EventBriefing.vue?vue&type=script&lang=ts&"
import style0 from "./EventBriefing.vue?vue&type=style&index=0&id=0adb041d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0adb041d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTabItem } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VCardActions,VCardText,VDivider,VIcon,VSpacer,VTabItem})
